import React from 'react';
import Grid from 'material-ui/Grid';
import Paper from 'material-ui/Paper';
import LineChart from 'react-linechart';
import TextField from 'material-ui/TextField';
import List, { ListItem, ListItemText, ListItemAvatar } from 'material-ui/List';
import Divider from 'material-ui/Divider';
import Avatar from 'material-ui/Avatar';
import PriorityHigh from 'material-ui-icons/PriorityHigh';
import GraphShareBtn from './ShareModal';
import { Redirect } from 'react-router-dom'
import isLoggedIn from '../helpers/isLoggedIn';
import { updateData, parseHeartRate, parseHeartEvent, getXDisplay } from '../helpers/graph';
import $ from 'jquery';
window.$ = $;

class HeartRate extends React.Component {

    constructor(props) {
        super(props);
        var oneWeekAgo = new Date();
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
        var customData = require('./mocks/HeartRateData.json');
        this.eventClicked = this.eventClicked.bind(this);

        this.state = {
            startDate: oneWeekAgo.toISOString().split('T')[0],
            endDate: new Date().toISOString().split('T')[0],
            chartData: customData.measures,
            events: customData.events,
            time: null,
            hidePoints: true,
            chartWidth: 800,
            chartHeight: 500,
        }
    }

    eventClicked(event) {
        this.setState({ hidePoints: false, time: event.timestamp.split(' ')[1], startDate: event.timestamp.split(' ')[0], endDate: event.timestamp.split(' ')[0] })
    }

    updateDimensions = () => {
        this.setState({chartWidth: $(window).width()-200});
    }
    componentWillMount() {
        this.updateDimensions();
    }
    componentDidMount() {
        window.addEventListener("resize", this.updateDimensions);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    render() {

        if (!isLoggedIn()) {
            return <Redirect to="/login" />;
        }

        return (
            <div className="main-container data-page">
                <Grid container spacing={40}>
                    <Grid item xs={12} align="center">
                        <h1>Heart Rate History</h1>
                    </Grid>
                </Grid>

                <Grid container spacing={40}>
                    <Grid item xs={12} className="range-container">
                        <Grid className="date-range">
                            <TextField
                                id="date-from"
                                label="From"
                                type="date"
                                defaultValue={this.state.startDate}
                                className="date"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onChange={updateData.bind(this)}
                            />
                            <TextField
                                id="date-to"
                                label="To"
                                type="date"
                                defaultValue={this.state.endDate}
                                className="date"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onChange={updateData.bind(this)}
                            />
                            <GraphShareBtn />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} className="graph-container">
                        <LineChart
                            width={this.state.chartWidth}
                            height={this.state.chartHeight}
                            minHeight={400}
                            minWidth={600}
                            data={
                                parseHeartRate(
                                    this.state.chartData,
                                    this.state.startDate,
                                    this.state.endDate,
                                    this.state.time
                                )}
                            xLabel={"Timestamp"}
                            yLabel={"BPM"}
                            options={
                                {
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    scales: {
                                        xAxes: [{
                                            time: {
                                                unit: 'second'
                                            }
                                        }]
                                    }
                                }
                            }

                            xDisplay={function (value) {
                                return getXDisplay(value)
                            }}
                            ticks={6}
                            hidePoints={this.state.hidePoints}
                            yMin={30}
                            yMax={190}
                            redraw
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Paper className={"box"}>
                            <div className={"colored-header"}>
                                <h3>Events</h3>
                            </div>
                            <div>
                                <List>
                                    {this.state.events.map((item, i) => (
                                        <ListItem button className="event" onClick={(e) => this.eventClicked(item)} key={i}>
                                            <ListItemAvatar>
                                                <Avatar>
                                                    <PriorityHigh />
                                                </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText primary={parseHeartEvent(item, this.state.time)} />
                                        </ListItem>
                                    ))}
                                    <Divider />
                                </List>
                            </div>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default HeartRate


// WEBPACK FOOTER //
// ./src/components/HeartRate.js